import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider, FieldArray } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';

import { loader_image } from "../_components/Imagepath";
// var ReactDOM = require('react-dom');
var Barcode = require('react-barcode');
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET, auth_id } from "../Global";
import $ from "jquery";
const EditRawMaterial = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  // const [palletezationType, setPalletezationType] = useState([]);
  const palletezationType = [

    {
      "value": 1,
      "label": "Farm Decay"
    }, {
      "value": 2,
      "label": "Raw Material"
    },

  ];
  // const [checkstatus, setCheckstatus] = useState([]);
  const checkstatus = [
    {
      "label": "Rejeter",
      "value": 1,
      "key": "address-0"
    },
    {
      "label": "Avec statistiques",
      "value": 2,
      "key": "address-1"
    },
    {
      "label": "Normal",
      "value": 3,
      "key": "address-2"
    }
  ];
  const [value, setValue] = useState({});
  const [productnameLists, setproductnameLists] = useState([]);
  const [valueContents, setValueContents] = useState([]);
  // const [valueQuality, setValueQuality] = useState([]);
  const [supplierName, setSupplierName] = useState([]);
  const [productLists, setproductLists] = useState([]);
  // const [incomingStatus, setIncomingStatus] = useState([]);
  // const [paymentStatus, setPaymentStatus] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  // const [rawMaterialID, setRawMaterialID] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [farmerLists, setFarmerLists] = useState([]);
  // const [customerNames, setcustomerNames] = useState([]);
  // const [newbarcode, setNewbarcode] = useState('');
  // const [updatebarcodeNmae, setUpdatebarcodeNmae] = useState('');
  // const [permission, setPermission] = useState({});
  const [permission, setPermission] = useState({});
  let season_id = localStorage.getItem("season_id");

  const [barcodeSuppliers, setBarcodeSuppliers] = useState([]);
  const [barcodeProducts, setBarcodeProducts] = useState([]);
  // const setIsButtonDisabled= (false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false); // New state for tracking initial load

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };




  // const handleFarmerChange = (e) => {
  //   formik.handleChange(e);
  //   customHandleInput(e);

  //   if (initialLoadComplete) { // Check if initial load is complete before calling generateLotNumber
  //     generateLotNumber(e);
  //   }
  // };

  const handleFarmerChange = (e) => {
    let event = e;

    // Check if it's a react-select option object instead of an event
    if (e && e.value !== undefined && !e.target) {
      // Create synthetic event for react-select
      event = {
        target: {
          name: 'farmer',
          value: e.value
        }
      };
    }

    formik.handleChange(event);
    customHandleInput(event);

    if (initialLoadComplete) {
      generateLotNumber(event.target.value);
    }
  };
  // const handleLocationChange = (e) => {
  //   formik.handleChange(e);
  //   customHandleInput(e);

  //   if (initialLoadComplete) { // Check if initial load is complete before calling generateLotNumber
  //     //generateLotNumber(e.target.value);
  //     generateLotNumberLocation(e);
  //   }
  // };

  const handleLocationChange = (e) => {
    let event = e;

    // Check if it's a react-select option object instead of an event
    if (e && e.value !== undefined && !e.target) {
      // Create synthetic event for react-select
      event = {
        target: {
          name: 'location',
          value: e.value
        }
      };
    }

    formik.handleChange(event);
    customHandleInput(event);

    if (initialLoadComplete) {
      generateLotNumberLocation(event.target.value);
    }
  };


  const formik = useFormik({
    initialValues: {
      id: value.id,
      season_id: season_id,
      lot_number_for_calculation: value.lot_number_for_calculation,
      lot_number: value.lot_number,
      plate_number: value.plate_number,
      driver_name: value.driver_name,
      farmer: value.farmer,
      shift_date: value.shift_date,
      // form_location: value.form_location,
      product: value.product,
      location: value.location,
      supplier: value.supplier,
      //customer: value.customer,
      // production_facility: value.production_facility,
      gross_weight: value.gross_weight,
      net_weight: value.net_weight,
      number_of_boxes: value.number_of_boxes,
      decay_net_weight: value.decay_net_weight,
      incoming_status: value.incoming_status,
      date_time: value.date_time,
      dominant_caliber: value.dominant_caliber,
      bl_number: value.bl_number,
      // rebate: value.rebate,
      // workers_cost: value.workers_cost,
      // transport_cost: value.transport_cost,
      // payment_status: value.payment_status,
      invoice: value.invoice,
      boxes_in: value.boxes_in,
      boxes_out: value.boxes_out,
      palletesation: valueContents,
      //quality_check: valueQuality,
      quality_check_calibre_dominant: value.quality_check_calibre_dominant, //varchar
      quality_check_petit_calibre: value.quality_check_petit_calibre,//varchar
      quality_check_dechet: value.quality_check_dechet,//varchar
      quality_check_status: value.quality_check_status,//int
      quality_check_remarks: value.quality_check_remarks,//text

    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/raw-materials/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {

          $("#form-submit").text("Update Raw material");
          delete backendErrors['error'];
          // actions.setSubmitting(false);
          setSubmitting(false);
          if (response.data.code === 200) {
            //  setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            //   actions.resetForm();
            setTimeout(() => {
              window.location.href = "/raw-materials";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });



  const getCategoryTypeProduct = (product_name) => {
    console.log(product_name);
    if (product_name != "") {
      axios
        .get(`/products/listing-category-type-groupby-specific/${product_name}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              let products = response.data.data.products;
              // let locationslisting = locations.map((ord, index) => ({
              //   text: ord.title,
              //   id: ord.id,
              //   key: `location-${index}`,
              // }));
              // setLocationLoading(locationslisting);
              let productslisting = products.map((customer, index) => ({
                label: customer.productname,
                value: customer.id,
                key: `address-${index}`,
              }));
              setproductLists(productslisting);
            } else {
              console.log("API response is not an array");
            }

          }
        })
        .catch((error) => {
          console.log(error);
        });
    }


  }


  let barcode_dattime = formik.values.date_time;
  // let barcode_arr  = barcode_dattime.split("T");
  // let  barcodetime  = barcode_arr[0] + ' '  + barcode_arr[1];
  let barcodetime = barcode_dattime;

  const handlePrint = (barcode_data) => {


    var form_value = formik.values;
    console.log(form_value);
    axios
      .post("/raw-materials/update", form_value, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        delete backendErrors['error'];
        if (response.data.code === 200) {
          //setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          //formik.values.id = formik.values.id;
          handleDownload(barcode_data);
        }

        else if (response.data.code === 422) {
          setBackendErrors(response.data.error);
        }
        else if (response.data.code === 401) {
          setBackendErrors(response.data.error);
        }
        else {
          setBackendErrors(response.data.error);
        }
      });
  };

  const handleDownload = (barcode_data) => {
    var supplierId = formik.values.supplier;
    var product_details = barcodeProducts.find(user => user.id == barcode_data.product);
    var supplier_details = barcodeSuppliers.find(user => user.id == supplierId);
    var suppler_name = (supplier_details && supplier_details.name) ? supplier_details.name : "";

    let get_contents = '';
    get_contents += '<div id="div-print">';
    get_contents += '<table classs="table" style="width:100%" >';
    get_contents += '<tr>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Lot Number#</td>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">' + value.lot_number + '</td>';
    get_contents += '</tr>';
    get_contents += '<tr>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Date And Time#</td>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">' + barcodetime + '</td>';
    get_contents += '</tr>';
    get_contents += '<tr>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Supplier</td>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">' + suppler_name + '</td>';
    get_contents += '</tr>';
    get_contents += '<tr>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Product</td>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">' + product_details.productname + '</td>';
    get_contents += '</tr>';
    get_contents += '<tr>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Gross Weight:</td>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">' + barcode_data.gross_weight + 'KG</td>';
    get_contents += '</tr>';
    get_contents += '<tr>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Net Weight:</td>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">' + barcode_data.net_weight + 'KG</td>';
    get_contents += '</tr>';
    get_contents += '<tr>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Boxes#</td>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">' + barcode_data.number_of_boxes + '</td>';
    get_contents += '</tr>';
    get_contents += '<tr>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Barcode#</td>';
    get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">' + barcode_data.barcode + '</td>';
    get_contents += '</tr>';
    get_contents += '</table><br/>';

    // Create temp div for React component (HIDDEN)
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = '-9999px';
    tempDiv.style.top = '-9999px';
    tempDiv.style.visibility = 'hidden';
    document.body.appendChild(tempDiv);

    const root = createRoot(tempDiv);
    root.render(<BarcodeComponent barcodeData={barcode_data.barcode} />);

    // ⭐ IMPORTANT: Wait for React to render before getting HTML
    setTimeout(() => {
      const barcodeHtml = tempDiv.innerHTML;
      get_contents += barcodeHtml;
      get_contents += '</div>';

      // Clean up the temporary div
      root.unmount();
      document.body.removeChild(tempDiv);

      // Print logic
      const width = 300;
      const height = 300;
      const widthInPixels = width * 3.779527559;
      const heightInPixels = height * 3.779527559;
      const left = (window.screen.width - widthInPixels) / 2;
      const top = (window.screen.height - heightInPixels) / 2;
      const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

      const printWindow = window.open('', '', windowFeatures);
      printWindow.document.open();
      printWindow.document.write('<html><head><title>Print</title></head><body style="font-size:25px;">');
      printWindow.document.write(get_contents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
      printWindow.close();
    }, 100); // 100ms wait for React render
  };

  // const BarcodeComponent = ({ barcodeData }) => {
  //   return (
  //     <div>
  //       <Barcode value={barcodeData} width={7} height={120} displayValue={false} />
  //     </div>
  //   );
  // };

  // BarcodeComponent.propTypes = {
  //   barcodeData: PropTypes.string.isRequired,
  // };

  // const handleDownload = (barcode_data) => {
  //    var supplierId = formik.values.supplier;
  //                 var product_details =  barcodeProducts.find(user => user.id == barcode_data.product);
  //                 var supplier_details =  barcodeSuppliers.find(user => user.id == supplierId);
  //                 var suppler_name = (supplier_details && supplier_details.name)?supplier_details.name:"";
  //                 console.log(formik.values);
  //                 let get_contents = '';
  //                 get_contents +=  '<div id="div-print">';
  //                     get_contents += '<table classs="table" style="width:100%" >';
  //                     get_contents += '<tr>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Lot Number#</td>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+value.lot_number+'</td>';
  //                     get_contents += '</tr>';
  //                     get_contents += '<tr>';
  //                     get_contents += '<tr>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Date And Time#</td>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcodetime+'</td>';
  //                     get_contents += '</tr>';
  //                     get_contents += '<tr>';

  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Supplier</td>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+suppler_name+'</td>';
  //                     get_contents += '</tr>';
  //                     get_contents += '<tr>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Product</td>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+product_details.productname+'</td>';
  //                     get_contents += '</tr>';
  //                     get_contents += '<tr>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Gross Weight:</td>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcode_data.gross_weight+'KG</td>';
  //                     get_contents += '</tr>';
  //                     get_contents += '<tr>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Net Weight:</td>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcode_data.net_weight+'KG</td>';
  //                     get_contents += '</tr>';
  //                     get_contents += '<tr>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Boxes#</td>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcode_data.number_of_boxes+'</td>';
  //                     get_contents += '</tr>';
  //                     get_contents += '<tr>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Barcode#</td>';
  //                     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcode_data.barcode+'</td>';
  //                     get_contents += '</tr>';
  //                     get_contents += ' </table>   <br/>';

  //                     // const tempDiv = document.createElement('div');
  //                     // ReactDOM.render(
  //                     // <BarcodeComponent barcodeData={barcode_data.barcode} />,
  //                     // tempDiv
  //                     // );
  //                     const tempDiv = document.createElement('div');
  //                     document.body.appendChild(tempDiv); // Append the div to the DOM

  //                     const root = createRoot(tempDiv);
  //                     root.render(<BarcodeComponent barcodeData={barcode_data.barcode} />);

  //                     // Get the HTML of the React component and append it to the container

  //                       setTimeout(() => {
  //                          const barcodeHtml = tempDiv.innerHTML;
  //                     get_contents +=  barcodeHtml;

  //                     get_contents +=  '</div>';


  //                     const width = 300; // width in millimeters
  //                     const height = 300; // height in millimeters

  //                     // Convert millimeters to pixels (assuming 1mm = 3.779527559 pixels)
  //                     const widthInPixels = width * 3.779527559;
  //                     const heightInPixels = height * 3.779527559;

  //                     // Calculate the position to center the window on the screen
  //                     const left = (window.screen.width - widthInPixels) / 2;
  //                     const top = (window.screen.height - heightInPixels) / 2;
  //                     const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

  //                     //  const printWindow = window.open('', '', 'width=800,height=800');
  //                     const printWindow = window.open('', '', windowFeatures);
  //                     printWindow.document.open();
  //                     printWindow.document.write('<html><head><title>Print</title></head><body style="font-size:25px;">');
  //                     printWindow.document.write(get_contents);
  //                     printWindow.document.write('</body></html>');
  //                     printWindow.document.close();
  //                     printWindow.print();
  //                     printWindow.close();

  //                       },100)

  // }
  // const BarcodeComponent = ({ barcodeData }) => {
  //   return (
  //     <div>
  //       <Barcode value={barcodeData} width={7} height={120}  displayValue={false} />
  //     </div>
  //   );
  // };
  const BarcodeComponent = ({ barcodeData }) => {
    return (
      <div>
        <Barcode value={barcodeData} width={7} height={120} displayValue={false} />
      </div>
    );
  };

  // **Add PropTypes validation**
  BarcodeComponent.propTypes = {
    barcodeData: PropTypes.string.isRequired, // Assuming barcodeData is a string
  };



  useEffect(() => {
    setPermission(FindModuleById(42));
    console.log(permission);



    axios
      .post(
        "/suppliers-trader/listing",
        {},
        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let suppliers = response.data.data.suppliers;
          setBarcodeSuppliers(suppliers);
          let supplierslist = suppliers.map((cat, index) => ({
            label: cat.name,
            value: cat.id,
            key: `categories-${index}`,
          }));
          setSupplierName(supplierslist);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/products/listing-groupby",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          // setBarcodeProducts(products);
          console.log(products);
          let productslisting = products.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `prodct-${index}`,
          }));
          setproductnameLists(productslisting);
          console.log(productnameLists);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/products/listing-category-type",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          setBarcodeProducts(products);
          let productslisting = products.map((customer, index) => ({
            label: customer.productname,
            value: customer.id,
            key: `address-${index}`,
          }));
          setproductLists(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // axios
    // .get(`/helpers/get-new-raw-material-palletisations`, {
    //   headers: {
    //     Authorization: `Bearer ${Authtoken}`,
    //     Apitoken: Apitoken,
    //   },
    // })
    // .then((response) => {
    //   if (response.data.code === 200) {
    //     let barcode = response.data.data.barcode;
    //     console.log(barcode);
    //     setNewbarcode(barcode);
    //   } else {
    //     console.log("API response is not an array");
    //   }
    // })
    // .catch((error) => {
    //   console.log(error);
    // });

    // raw_data_invoice ='';

    axios
      .get(`/raw-materials/edit/${season_id + '-' + id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.raw);
          setValueContents(response.data.data.raw.palletesation);
          setInitialLoadComplete(true); // Mark initial data load as complete

          //setValueQuality(response.data.data.raw.quality_check);


        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.locations;
          let locationslisting = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `location-${index}`,
          }));
          setLocationLoading(locationslisting);
          //setLocationLoading(locations);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });



    axios
      .post(
        "/farmers/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let farmers = response.data.data.farmers;
          let productslisting = farmers.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `farmer-${index}`,
          }));
          setFarmerLists(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/products/listing",
        {},
        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          let productslisting = products.map((customer, index) => ({
            // text: customer.name,
            label: customer.name + " (" + customer.category.title + ") " + " (" + customer.type.title + ")",
            value: customer.id,
            key: `address-${index}`,
          }));
          setproductLists(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });



    axios
      .post(
        "/suppliers-trader/listing",
        {},
        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let suppliers = response.data.data.suppliers;
          let supplierslist = suppliers.map((cat, index) => ({
            label: cat.name,
            value: cat.id,
            key: `categories-${index}`,
          }));
          setSupplierName(supplierslist);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);



  const updateShiftDate = (datetime_value) => {
    const Input_name = datetime_value;
    var datee_timee = Input_name.split('T');
    var timee = datee_timee[1].split(":");

    console.log(datee_timee);


    if (timee[0] >= 0 && timee[0] < 12) {
      const date = new Date(datee_timee[0]);
      date.setDate(date.getDate() - 1);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      var ladtdate = `${year}-${month}-${day}`;
      console.log(ladtdate);
      formik.values.shift_date = ladtdate;
      //formik.setFieldValue('shift_date', ladtdate);
      $("#shift_date").val(ladtdate);
      $("#shift_date").attr('value', ladtdate);

    } else {
      formik.values.shift_date = datee_timee[0];

      console.log(datee_timee);
      //formik.setFieldValue('shift_date', datee_timee[0]);
      $("#shift_date").val(datee_timee[0]);
      $("#shift_date").attr('value', datee_timee[0]);
    }
  };



  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };


  const deleteBarcodeFromDB = (item_id) => {
    if (!window.confirm("Are you sure you want to delete this barcode?")) {
      return { status: 'cancelled' }; // user cancelled
    }
    const response_data = {};
    response_data.status = 'false';
    axios.get(`/raw-materials/delete-barcode/${season_id + '-' + item_id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        response_data.status = 'ok';
        return response_data;
      }
    }).catch((error) => {
      console.log(error)
      response_data.status = 'false';

    });
    return response_data;
  };


  const checkLotNUmber = (lot_number) => {
    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id

    let lot_number_for_calculation = formik.values.lot_number_for_calculation

    let check_lotnumber = lot_number + ',' + lot_number_for_calculation + ',' + raw_material_id + ',' + season_id;
    axios.get(`/raw-materials/edit-check-lot-number/${check_lotnumber}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
      .then((response) => {

        if (response.data.code === 422) {
          setBackendErrors(response.data.error);
        } else {
          console.log(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }


  const generateLotNumber = (farmer) => {
    console.log("autoload3");

    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id
    let lotnumber = formik.values.date_time + "_" + farmer + '_' + formik.values.location + '_' + raw_material_id + '_' + season_id;
    if (formik.values.date_time != "" && farmer != "" && formik.values.location != '') {
      console.log('page load');
      axios.get(`/raw-materials/edit-generate-lot-number/${lotnumber}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              formik.setFieldValue('lot_number', response.data.data.lot_number_generated);
              formik.setFieldValue('lot_number_for_calculation', response.data.data.lot_number_generated_for_calculation);
            } else {
              console.log("API response is not an array");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  const generateLotNumberLocation = (location) => {
    console.log("autoload2");

    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id
    let lotnumber = formik.values.date_time + "_" + formik.values.farmer + '_' + location + '_' + raw_material_id + '_' + season_id;
    if (formik.values.date_time != "" && formik.values.farmer != "" && location != '') {
      console.log('page load');
      axios.get(`/raw-materials/edit-generate-lot-number/${lotnumber}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              formik.setFieldValue('lot_number', response.data.data.lot_number_generated);
              formik.setFieldValue('lot_number_for_calculation', response.data.data.lot_number_generated_for_calculation);
            } else {
              console.log("API response is not an array");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // Recalculate all existing palletesation items when location changes
  if (formik.values.palletesation && formik.values.palletesation.length > 0) {
    formik.values.palletesation.forEach((pallet, index) => {
      const grossWeight = pallet.gross_weight ? parseFloat(pallet.gross_weight) : 0;
      const numberOfBoxes = pallet.number_of_boxes ? parseFloat(pallet.number_of_boxes) : 0;
      
      let netWeight = 0;
      if (location == 6) {
        netWeight = (grossWeight - (numberOfBoxes * 2.8)) - 24;
      } else {
        netWeight = (grossWeight - (numberOfBoxes * 2.8)) - 21;
      }
      const newNetWeight = Math.floor(netWeight);
      
      formik.setFieldValue(`palletesation[${index}].net_weight`, newNetWeight);
    });
  }
  }

  const generateLotNumberDateTime = (date_time_rat) => {
    console.log("autoload1");
    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id
    let date_time = date_time_rat + ":00";
    let lotnumber = date_time + "_" + formik.values.farmer + '_' + formik.values.location + '_' + raw_material_id + '_' + season_id;
    if (formik.values.farmer != "" && formik.values.location != "" && date_time != "") {
      axios
        .get(`/raw-materials/edit-generate-lot-number/${lotnumber}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              formik.setFieldValue('lot_number', response.data.data.lot_number_generated);
              formik.setFieldValue('lot_number_for_calculation', response.data.data.lot_number_generated_for_calculation);

            } else {
              console.log("API response is not an array");
            }

          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-materials">Raw Material</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Raw Material Info</h4>
                    {permission?.update == 1 && (
                      <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date Time</label>
                                <input
                                  type="datetime-local"
                                  name="date_time"
                                  value={formik.values.date_time}
                                  className={
                                    backendErrors.date_time
                                      ? "form-input form-control input-error datetimepicker"
                                      : "form-input form-control datetimepicker"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    updateShiftDate(e.target.value);
                                    generateLotNumberDateTime(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                                <small>
                                  {backendErrors.date_time && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date_time}
                                    </span>
                                  )}
                                </small>
                              </div>
                              <div className="form-group">
                                <label>Lot Number</label>
                                <input
                                  type="text"
                                  name="lot_number"
                                  value={formik.values.lot_number}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    checkLotNUmber(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <input
                                  type="hidden"
                                  name="lot_number_for_calculation"
                                  value={formik.values.lot_number_for_calculation}
                                  className="form-input form-control"
                                // onChange={(e) => {
                                //   formik.handleChange(e);
                                //   customHandleInput(e);
                                // }}
                                // onBlur={formik.handleBlur}
                                />

                                <small>
                                  {backendErrors?.lot_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.lot_number}
                                    </span>
                                  )}
                                </small>
                              </div>
                              <div className="form-group">
                                <label>Plate Number</label>
                                <input
                                  type="text"
                                  name="plate_number"
                                  value={formik.values.plate_number}
                                  className={
                                    backendErrors.plate_number
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }} onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.plate_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.plate_number}
                                    </span>
                                  )}
                                </small>
                              </div>


                              <div className="form-group status">
                                <label>Supplier Name</label>
                                {supplierName.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={supplierName.find(option => option.value == formik.values.supplier) || null} // Ensure correct format
                                    name="supplier"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("supplier", selectedOption);
                                      //   generateLotNumberLocation(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={supplierName}
                                    placeholder="Select"


                                  />
                                )}

                                <small>
                                  {backendErrors.supplier && (
                                    <span className="form-error mt-1">
                                      {backendErrors.supplier}
                                    </span>
                                  )}
                                </small>
                              </div>
                              <div className="form-group">
                                <label>BL Gross Weight</label>
                                <div className="input-group">
                                  <input type="text"
                                    name="gross_weight"
                                    value={formik.values.gross_weight}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="BL Gross Weight" aria-label="BL Gross Weight" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">KG</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.gross_weight && (
                                    <span className="form-error mt-1">
                                      {backendErrors.gross_weight}
                                    </span>
                                  )}
                                </small>
                              </div>


                              <div className="form-group status">
                                <label>Product</label>
                                <Select
                                  className="w-100"
                                  value={productnameLists.find(option => option.value == formik.values.product) || null} // Ensure correct format
                                  name="product"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("product", selectedOption);
                                    getCategoryTypeProduct(selectedOption.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={productnameLists}
                                  placeholder="Select"

                                />
                                <small>
                                  {backendErrors.product && (
                                    <span className="form-error mt-1">
                                      {backendErrors.product}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">

                              <div className="form-group status">
                                <label>Select Farm</label>
                                {farmerLists.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={farmerLists.find(option => option.value == formik.values.farmer) || null} // Ensure correct format
                                    name="farmer"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("farmer", selectedOption);
                                      generateLotNumber(selectedOption.value);
                                      handleFarmerChange(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={farmerLists}
                                    placeholder="Select"


                                  />
                                )}


                                <small>
                                  {backendErrors.farmer && (
                                    <span className="form-error mt-1">
                                      {backendErrors.farmer}
                                    </span>
                                  )}
                                </small>
                              </div>
                              <div className="form-group">
                                <label>Driver Name</label>
                                <input
                                  type="text"
                                  name="driver_name"
                                  value={formik.values.driver_name}
                                  className={
                                    backendErrors.driver_name
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.driver_name && (
                                    <span className="form-error mt-1">
                                      {backendErrors.driver_name}
                                    </span>
                                  )}
                                </small>
                              </div>

                              <div className="form-group status">
                                <label>Location</label>
                                {locationLoading.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                                    name="location"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("location", selectedOption);
                                      generateLotNumberLocation(selectedOption.value);
                                      handleLocationChange(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={locationLoading}
                                    placeholder="Select"


                                  />
                                )}
                                <small>
                                  {backendErrors.location && (
                                    <span className="form-error mt-1">
                                      {backendErrors.location}
                                    </span>
                                  )}
                                </small>
                              </div>

                              <div className="form-group">
                                <label>BL Net Weight</label>
                                <div className="input-group">
                                  <input type="text"
                                    name="net_weight"
                                    value={formik.values.net_weight}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="BL Net Weight" aria-label="BL Net Weight" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">KG</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.net_weight && (
                                    <span className="form-error mt-1">
                                      {backendErrors.net_weight}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Palletesation
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="palletesation"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  id="add-barcode-button"
                                  onClick={async () => {
                                    if ($("#add-barcode-button").prop("disabled")) return;
                                    $("#loader-image-add-palletesation").removeClass('loader-hide');
                                    $("#loader-image-add-palletesation").addClass('loader-show');

                                    //setIsButtonDisabled(true);
                                    $("#add-barcode-button").prop("disabled", true);
                                    $("#add-barcode-button").attr('disabled', 'disabled');

                                    try {
                                      await new Promise(resolve => setTimeout(resolve, 500));
                                      let new_para = { 'season_id': season_id }
                                      axios.get(`/helper/next-raw-material-pallet`, {
                                        params: new_para,
                                        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken, },
                                      }).then((response) => {
                                        if (response.data.code === 200) {

                                          let abc_barcode = response.data.data.barcode;
                                          let rawbarcode = (abc_barcode.barcode != null) ? abc_barcode.barcode : '';


                                          let appendArr_1 = arrayHelpers.form.values.palletesation && arrayHelpers.form.values.palletesation[0];

                                          let type_pallet = (appendArr_1 && appendArr_1.type) ? appendArr_1.type : "";
                                          let product_pallet = (appendArr_1 && appendArr_1.product) ? appendArr_1.product : "";
                                          //let net_weight_pallet = (appendArr_1 && appendArr_1.net_weight) ? appendArr_1.net_weight : "";
                                          //let gross_weight_pallet = (appendArr_1 && appendArr_1.gross_weight) ? appendArr_1.gross_weight : "";
                                          let number_of_boxes_pallet = (appendArr_1 && appendArr_1.number_of_boxes) ? appendArr_1.number_of_boxes : "";


                                          let initialArr = {
                                            barcode: rawbarcode,
                                            type: type_pallet,
                                            product: product_pallet,
                                            net_weight: '',
                                            gross_weight: '',
                                            number_of_boxes: number_of_boxes_pallet,
                                          }
                                          arrayHelpers.push(initialArr);

                                          //setIsButtonDisabled(false);
                                          $("#add-barcode-button").prop("disabled", false).removeAttr('disabled');

                                          $("#add-barcode-button").prop("disabled", false);
                                          $("#add-barcode-button").removeAttr('disabled');
                                          $("#loader-image-add-palletesation").addClass('loader-hide');
                                          $("#loader-image-add-palletesation").removeClass('loader-show');

                                        }
                                      });


                                    } catch (error) {
                                      console.error('Error:', error);
                                    } finally {
                                      console.error('Error: finally');

                                    }

                                  }}
                                >
                                  +
                                  <img id={`loader-image-add-palletesation`} className="loader-image loader-hide" src={loader_image} />
                                </button>
                                {formik.values.palletesation.map(
                                  (friend, index) => (
                                    <div className="row" key={index}>

                                      <div className="col-md-2">
                                        <div className="form-group status">
                                          <label>Barcode</label>

                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`palletesation[${index}].barcode`}
                                            value={
                                              formik.values.palletesation[index]
                                                .barcode
                                            }

                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-2">
                                        <div className="form-group status">
                                          <label>Product</label>
                                          {productLists.length > 0 && (
                                            <Select
                                              name={`palletesation[${index}].product`}
                                              options={productLists}
                                              value={productLists.find(option => option.value == formik.values.palletesation[index].product) || null} // Ensure correct format
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`palletesation[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                customHandleInput({
                                                  target: {
                                                    name: `palletesation[${index}].product`,
                                                    value: selectedOption.value, // ✅ Ensure only value is passed
                                                  },
                                                });
                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select"
                                              className="w-100"


                                            />
                                          )}

                                        </div>
                                      </div>
                                      <div className="col-md-1">
                                        <div className="form-group status">
                                          <label>Type</label>
                                          {palletezationType.length > 0 && (
                                            <Select
                                              name={`palletesation[${index}].type`}
                                              options={palletezationType}
                                              value={palletezationType.find(option => option.value == formik.values.palletesation[index].type) || null} // Ensure correct format
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`palletesation[${index}].type`, selectedOption.value); // ✅ Store only value in Formik
                                                customHandleInput({
                                                  target: {
                                                    name: `palletesation[${index}].type`,
                                                    value: selectedOption.value, // ✅ Ensure only value is passed
                                                  },
                                                });
                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select"
                                              className="w-100"

                                            />
                                          )}
                                        </div>
                                      </div>

                                      <div className="col-md-2">
                                        <div className="form-group status">
                                          <label>Gross Weight</label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-input form-control"
                                              name={`palletesation[${index}].gross_weight`}
                                              value={
                                                formik.values.palletesation[index]
                                                  .gross_weight
                                              }
                                              onKeyPress={(event) => {
                                                // Allow only numbers (0-9)
                                                if (!/^[0-9]$/.test(event.key)) {
                                                  event.preventDefault();
                                                }

                                              }}

                                              // onChange={(event) => {
                                              //   formik.handleChange(event);
                                              //   const updatedGrossWeight = event.target.value ? parseFloat(event.target.value) : 0;
                                              //   const numberOfBoxes = formik.values.palletesation[index].number_of_boxes ? parseFloat(formik.values.palletesation[index].number_of_boxes) : 0;
                                              //   const netWeight = (updatedGrossWeight - (numberOfBoxes * 2.8)) - 21;
                                              //     const wholeNumber = parseFloat(netWeight);
                                              //     const newNetWeight = Math.floor(wholeNumber)
                                              //     formik.setFieldValue(`palletesation[${index}].net_weight`, newNetWeight);
                                              //   formik.setFieldValue(`palletesation[${index}].net_weight`, newNetWeight);
                                              // }}
                                              // For Gross Weight input:
                                              onChange={(event) => {
                                                const newGrossWeight = event.target.value ? parseFloat(event.target.value) : 0;
                                                const numberOfBoxes = formik.values.palletesation[index].number_of_boxes
                                                  ? parseFloat(formik.values.palletesation[index].number_of_boxes)
                                                  : 0;

                                                // Calculate net weight
                                                // const netWeight = (newGrossWeight - (numberOfBoxes * 2.8)) - 21;
                                                let netWeight = 0;
                                                if (formik.values.location == 6) {
                                                  netWeight = (newGrossWeight - (numberOfBoxes * 2.8)) - 24;
                                                } else {
                                                  netWeight = (newGrossWeight - (numberOfBoxes * 2.8)) - 21;
                                                }
                                                const newNetWeight = Math.floor(netWeight);

                                                // Update both values at once
                                                formik.setFieldValue(`palletesation[${index}].gross_weight`, event.target.value);
                                                formik.setFieldValue(`palletesation[${index}].net_weight`, newNetWeight);
                                              }}
                                              placeholder="Gross Weight" aria-label="Gross Weight" aria-describedby="basic-addon2" />
                                            <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">KG</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>


                                      <div className="col-md-1">
                                        <div className="form-group status">
                                          <label>Boxes</label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-input form-control"
                                              name={`palletesation[${index}].number_of_boxes`}
                                              value={
                                                formik.values.palletesation[index]
                                                  .number_of_boxes
                                              }
                                              onKeyPress={(event) => {
                                                // Allow only numbers (0-9)
                                                if (!/^[0-9]$/.test(event.key)) {
                                                  event.preventDefault();
                                                }

                                              }}
                                              // onChange={(event) => {
                                              //   formik.handleChange(event);
                                              //   const updatedNumberOfBoxes = event.target.value ? parseFloat(event.target.value) : 0;
                                              //   const grossWeight = formik.values.palletesation[index].gross_weight ? parseFloat(formik.values.palletesation[index].gross_weight) : 0;
                                              //   const netWeight = (grossWeight - (updatedNumberOfBoxes * 2.8)) - 21;
                                              //   const wholeNumber = parseFloat(netWeight);
                                              //   const newNetWeight = Math.floor(wholeNumber)
                                              //   formik.setFieldValue(`palletesation[${index}].net_weight`, newNetWeight);
                                              //   formik.setFieldValue(`palletesation[${index}].net_weight`, newNetWeight);
                                              // }}   
                                              onChange={(event) => {
                                                const newNumberOfBoxes = event.target.value ? parseFloat(event.target.value) : 0;
                                                const grossWeight = formik.values.palletesation[index].gross_weight
                                                  ? parseFloat(formik.values.palletesation[index].gross_weight)
                                                  : 0;

                                                // Calculate net weight
                                                //const netWeight = (grossWeight - (newNumberOfBoxes * 2.8)) - 21;
                                                let netWeight = 0;
                                                if (formik.values.location == 6) {
                                                  netWeight = (grossWeight - (newNumberOfBoxes * 2.8)) - 24;
                                                } else {
                                                  netWeight = (grossWeight - (newNumberOfBoxes * 2.8)) - 21;
                                                }
                                                const newNetWeight = Math.floor(netWeight);

                                                // Update both values at once
                                                formik.setFieldValue(`palletesation[${index}].number_of_boxes`, event.target.value);
                                                formik.setFieldValue(`palletesation[${index}].net_weight`, newNetWeight);
                                              }}
                                              placeholder="Boxes" aria-label="Number of Boxes" aria-describedby="basic-addon2" />

                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-2">
                                        <div className="form-group status">
                                          <label>Net Weight</label>
                                          <input
                                            type="hidden"
                                            name={`palletesation[${index}].palletesation_id`}
                                            value={formik.values.palletesation[index].id
                                            }
                                          />
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-input form-control"
                                              name={`palletesation[${index}].net_weight`}
                                              value={
                                                formik.values.palletesation[index]
                                                  .net_weight
                                              }
                                              onKeyPress={(event) => {
                                                // Allow only numbers (0-9)
                                                if (!/^[0-9]$/.test(event.key)) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={formik.handleChange}
                                              placeholder="Net Weight" aria-label="Net Weight" aria-describedby="basic-addon2" />
                                            <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">KG</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-md-2">
                                        <div className="form-group status text-center">
                                          <label>ACTION</label>

                                          <div className="input-group" style={{ display: 'block' }}>
                                            <div>
                                              <button type="button" onClick={() => handlePrint(formik.values.palletesation[index])} className="btn btn-primary me-1"  > <i className="fa fa-print" /> <img id={`item-${formik.values.palletesation[index].barcode}`} className="loader-image loader-hide" src={loader_image} />  </button>
                                              <button
                                                className="btn btn-danger"
                                                type="button"
                                                onClick={() => {
                                                  let item_record = formik.values.palletesation[index];
                                                  if (item_record.id == undefined) {
                                                    arrayHelpers.remove(index)
                                                  } else {
                                                    deleteBarcodeFromDB(item_record.id);
                                                    arrayHelpers.remove(index)
                                                  }
                                                }}
                                              >
                                                -
                                              </button>

                                              {index === formik.values.palletesation.length - 1 && (
                                                <button
                                                  className="btn btn-primary "
                                                  type="button"
                                                  id="add-barcode-button2"
                                                  onClick={async () => {
                                                    // Add palletization logic
                                                    if ($("#add-barcode-button").prop("disabled")) return;
                                                    $("#loader-image-add-palletesation2").removeClass('loader-hide');
                                                    $("#loader-image-add-palletesation2").addClass('loader-show');

                                                    // setIsButtonDisabled(true);
                                                    $("#add-barcode-button2").prop("disabled", true);
                                                    $("#add-barcode-button2").attr('disabled', 'disabled');

                                                    try {
                                                      await new Promise(resolve => setTimeout(resolve, 500));
                                                      let new_para = { 'season_id': season_id }
                                                      axios.get(`/helper/next-raw-material-pallet`, {
                                                        params: new_para,
                                                        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                                                      }).then((response) => {
                                                        if (response.data.code === 200) {
                                                          let abc_barcode = response.data.data.barcode;
                                                          let rawbarcode = abc_barcode.barcode || '';
                                                          let appendArr_1 = arrayHelpers.form.values.palletesation[0];

                                                          let initialArr = {
                                                            barcode: rawbarcode,
                                                            type: appendArr_1.type || "",
                                                            product: appendArr_1.product || "",
                                                            net_weight: '',
                                                            gross_weight: '',
                                                            number_of_boxes: appendArr_1.number_of_boxes || "",
                                                          };

                                                          arrayHelpers.push(initialArr);

                                                          //setIsButtonDisabled(false);
                                                          $("#add-barcode-button2").prop("disabled", false).removeAttr('disabled');
                                                          $("#loader-image-add-palletesation2").addClass('loader-hide').removeClass('loader-show');
                                                        }
                                                      });
                                                    } catch (error) {
                                                      console.error('Error:', error);
                                                    }
                                                  }}
                                                >
                                                  +
                                                  <img id={`loader-image-add-palletesation`} className="loader-image loader-hide" src={loader_image} />
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* <div className="col-md-1 text-center">
                                    <div className="form-group">
                                     
                                    </div>
                                  </div> */}
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                          />
                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Quality Check
                              </h4>
                            </div>
                          </div>
                          <div className="row">

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Calibre Dominant</label>
                                <div className="input-group">
                                  <input type="text"
                                    name="quality_check_calibre_dominant"
                                    value={formik.values.quality_check_calibre_dominant}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Calibre Dominant" />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Petit Calibre</label>
                                <div className="input-group">
                                  <input type="text"
                                    name="quality_check_petit_calibre"
                                    value={formik.values.quality_check_petit_calibre}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Petit Calibre" />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Dechet</label>
                                <div className="input-group">
                                  <input type="text"
                                    name="quality_check_dechet"
                                    value={formik.values.quality_check_dechet}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Dechet" />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Select Status</label>
                                <Select
                                  className="w-100"
                                  value={checkstatus.find(option => option.value == formik.values.quality_check_status) || null} // Ensure correct format
                                  name="quality_check_status"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("quality_check_status", selectedOption);
                                    //generateLotNumberLocation(selectedOption.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={checkstatus}
                                  placeholder="Select"

                                />
                              </div>
                            </div>


                            <div className="col-md-12">
                              <div className="form-group status">
                                <label>Remarks</label>
                                <textarea

                                  className="form-input form-control"
                                  name='quality_check_remarks'
                                  value={formik.values.quality_check_remarks}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Enter Remarks"
                                ></textarea>
                              </div>
                            </div>

                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <h4 className="card-title">
                                <br />
                                Crates follow Up
                              </h4>
                            </div>
                          </div>

                          <div className="row">

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Boxes IN</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    name="boxes_in"
                                    value={formik.values.boxes_in}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Boxes IN" />


                                </div>
                              </div>
                            </div>

                            {/* <div className="col-md-6">
                          <div className="form-group">
                            <label>Boxes OUT</label>
                                <div className="input-group">
                                <input 
                                       type="text"
                                       onKeyPress={(event) => {
                                         // Allow only numbers (0-9)
                                         if (!/^[0-9.]$/.test(event.key)) {
                                           event.preventDefault();
                                         }
                                       }}
                                      name="boxes_out"
                                      value={formik.values.boxes_out}
                                      onChange={(e) => {
                                        formik.handleChange(e);
                                        customHandleInput(e);
                                      }}
                                      onBlur={formik.handleBlur}
                                      className="form-control" placeholder="Boxes OUT"  />
                                    

                              </div>
                          </div>
                        </div>  */}




                          </div>



                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                              Update Raw material
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditRawMaterial;
